import styled from "styled-components";

export const Title = styled.h1`
  ${({ theme }) => theme.font.heading.x};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme, dark }) =>
    dark
      ? theme.colors.primary.cetaceanBlue
      : theme.colors.primary.vividCerulean};
`;
